import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackEvent, trackPageView, ANALYTICS_EVENTS } from './index';

export default function AnalyticsRouteTracker() {
    const { pathname, search } = useLocation();
    useEffect(() => {
        trackPageView(`${pathname}${search}`);
        if (pathname === '/') trackEvent(ANALYTICS_EVENTS.LANDING_PAGE_VIEWED, { source: 'direct' }, { onceKey: 'landing' });
    }, [pathname, search]);
    return null;
}
